// What every installer screen shows when the deployment runs no installer: the routes answer 503
// `unavailable` with INSTALLER_DISABLED_MESSAGE, which is a setting, not an outage to retry.
import { EmptyState, PageHeader } from "@nexus/ui";

export function InstallerDisabled() {
  return (
    <div class="page">
      <PageHeader title="Installer" />
      <div role="status">
        <EmptyState
          title="The installer is not enabled"
          lede={
            <>
              The agentic installer isn't enabled in this deployment, so AWS accounts, installer sessions and changes are
              not available here. An operator turns it on with the Usage API stack's <code>installer_enabled</code> setting.
            </>
          }
        />
      </div>
    </div>
  );
}
